module.exports = __webpack_public_path__ + "img/logo-back.8021d190.png";